export default `
  <div class="wb-doc-page">
    <div class="doc-page-title">活動條款</div>
    <div class="doc-main-title">一、活動時間</div>
    <div class="doc-text">即日起至2022年12月31日 23:59:59</div>

    <div class="doc-main-title">二、活動對象</div>
    <div class="doc-text">限特選用戶參與</div>

    <div class="doc-main-title">三、獎勵規則</div>
    <div class="doc-text doc-pb28">1. 完成首筆入金大於2萬港元或以上，30天內無出金記錄且30天內交易一次可獲得400港元現金獎勵;</div>
    <div class="doc-text">2. 完成首筆入金大於10萬港元或以上，30天內無出金記錄且30天內交易一次可獲得1500港元現金獎勵;</div>

    <div class="doc-main-title">四、獎勵發放及領取</div>
    <div class="doc-text doc-pb28">1. 港股LV2行情需完成新註冊、及首筆入金到賬後系統自動發放，第二個交易日生效;</div>
    <div class="doc-text">2. 現金獎勵券需客戶滿足入金後30天內未有出金記錄且30天內有一筆港股交易的要求，達標後系統會自動發放，逾期無效，不另補發;</div>

    <div class="doc-main-title">五、活動其他條款及細則</div>
    <div class="doc-text doc-pb28">1. 特選用戶是指持有中國大陸身份證且常駐地在中國大陸的用戶;</div>
    <div class="doc-text doc-pb28">2. 新註冊客戶可獲得30天免費港股行情報價, 首筆入金10萬港元或以上的客戶可再獲得30天免費行情報價,  活動期間提供的行情服務，僅限用戶在中國大陸使用;</div>
    <div class="doc-text doc-pb28">3. 首筆存入資金為實際完成存入資金的到賬金額;</div>
    <div class="doc-text doc-pb28">4. 存入資金必須來自於認可銀行的同名個人賬戶，本公司不接受第叁者賬戶入金;</div>
    <div class="doc-text doc-pb28">5. 每位客戶只能獲取一次現金獎勵，不可重複;</div>
    <div class="doc-text doc-pb28">6. 如發現包括但不限於通過軟件惡意刷獎、手機號碼異常、盜取他人信息、邀請人IP異常等行為，盈寶證券有權取消或凍結其活動獎勵;</div>
    <div class="doc-text doc-pb28">7. 此活動由盈寶證券國際(香港)有限公司("盈寶證券")提供。本活動並非及不應被視為任何證券、金融產品或工具邀約、要約、招攬、邀請、建議、意見或任何投資決策的見議，亦不應被視為專業意見。瀏覽本活動的人士在作出任何投資決定之前，應完全了解其風險以及相關法律，涉及的稅項及會計的特點及後果，並根據個人的情況決定投資是否適合個人的財政狀況及投資目標，以及有關風險的承受能力，有需要時應尋找適當的專業意見。本廣告由本公司提供，內容未經香港證券及期貨事務監察委員會審閱。盈寶證券保留更改活動條款及細則⼂更改或終止任何優惠的權利，而毋須另行通知。本活動的獎勵資格及數據確認以盈寶證券後台數據為準，若有任何爭議，盈寶證券保留本活動的最終解釋權及決定權，如您有任何疑問，請致電客服熱線(852)  2370 9538 或通過在線客服諮詢。 </div>
  </div>
`
